import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockInReportResponseDto } from './stock-in-report-response.dto';

export class StockInReportResponseModel extends GlobalResponseObject {
    data?: StockInReportResponseDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StockInReportResponseDto){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}